/** xorshift32: seeded, integer-only, identical across JS engines. */
export interface Rng {
  state: number;
}

export function createRng(seed: number): Rng {
  const s = seed >>> 0;
  return { state: s === 0 ? 0x9e3779b9 : s };
}

export function nextU32(rng: Rng): number {
  let x = rng.state;
  x ^= x << 13;
  x ^= x >>> 17;
  x ^= x << 5;
  rng.state = x >>> 0;
  return rng.state;
}

/** Integer in [0, n). */
export function nextInt(rng: Rng, n: number): number {
  return nextU32(rng) % n;
}
